<template>
  <div>
    <div class="title">权限管理</div>
    <div class="container">
      <span>权限搜索 :</span>
      <el-input
        v-model="menuname"
        placeholder="请输入内容"
        style="width:200px;margin-left:10px;margin-right:10px"
      ></el-input>
      <span>父级权限 :</span>
      <el-select
        v-model="menuid"
        placeholder="请选择"
        style="margin-left:10px;margin-right:10px"
        :clearable="true"
      >
        <el-option
         v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="query" v-if="searchShow">查询</el-button>
      <el-button class="all" @click="reset">所有权限</el-button>
      <el-button type="primary" class="addbtn" @click="addpower" v-if="addnewShow">添加权限</el-button>
      <div class="tabletype">
        <el-table :data="tableData" stripe>
          <el-table-column prop="name" label="权限名称"></el-table-column>
          <el-table-column prop="parentName" label="父级菜单">
            <template slot-scope="scope">
              <div>{{scope.row.parentName?scope.row.parentName:"/"}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="菜单类型">
            <template slot-scope="scope">
              <div>{{scope.row.type?menutypeoption[scope.row.type]:null}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="path" label="对应路径"></el-table-column>
          <el-table-column prop="address" label="操作" align="right">
            <template slot-scope="scope">
              <div>
                <span style="margin-right:10px;cursor:pointer" @click="edit(scope.row)" v-if="editShow">
                  <img src="../images/edit.png" />
                </span>
                <span style="cursor:pointer">
                  <img src="../images/delete.png" @click="deletebtn(scope.row.menuId)" v-if="deleteShow"/>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationmain">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalpage"
            :current-page="pageNum"
            @current-change="operatesizechange"
            hide-on-single-page
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- </el-card> addnew-->

    <el-dialog :visible.sync="addVisible" title="添加权限" width="400px" :show-close="false" top="10vh">
      <div slot="title">
        <p>添加权限</p>
        <i class="el-icon-error" @click="addVisible = false" style="cursor:pointer"></i>
      </div>
      <el-form :model="userForm" :rules="rules" ref="userForm" label-position="top">
        <el-form-item prop="menuName" label="菜单名称 :">
          <el-input v-model="userForm.menuName" placeholder="请输入菜单名称" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="path" label="前端路径 :">
          <el-input v-model="userForm.path" placeholder="请输入前端路径" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="orderNum" label="显示顺序 :">
          <el-input v-model="userForm.orderNum" placeholder="请输入显示顺序" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="icon" label="图标 :">
          <el-input v-model="userForm.icon" placeholder="请输入图标" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="parentId" label="父级菜单 :">
          <el-select v-model="userForm.parentId" placeholder="请选择父级菜单" style="width:100%">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="menuType" label="菜单类型 :">
          <el-select v-model="userForm.menuType" placeholder="请选择菜单类型" style="width:100%">
            <el-option
              v-for="item in menuoptions"
              :key="item.value"
              :label="item.label"
              @change="power"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialogBtn">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="editVisible"
      title="修改权限"
      width="400px"
      :show-close="false"
      top="10vh"
    >
      <div slot="title">
        <p>修改权限</p>
        <i class="el-icon-error" @click="editVisible = false" style="cursor:pointer"></i>
      </div>
      <el-form :model="editForm" ref="editForm" label-position="top">
        <el-form-item prop="name" label="菜单名称 :">
          <el-input v-model="editForm.name" placeholder="请输入菜单名称" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="path" label="前端路径 :">
          <el-input v-model="editForm.path" placeholder="请输入前端路径" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="orderNum" label="显示顺序 :">
          <el-input v-model="editForm.orderNum" placeholder="请输入显示顺序" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="icon" label="图标 :">
          <el-input v-model="editForm.icon" placeholder="请输入图标" style="width:100%"></el-input>
        </el-form-item>
        <el-form-item prop="parentId" label="父级菜单 :">
          <el-select v-model="editForm.parentId" placeholder="请选择父级菜单" style="width:100%">
            <el-option
            v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="menuType" label="菜单类型 :">
          <el-select v-model="editForm.type" placeholder="请选择菜单类型" style="width:100%">
            <el-option
              v-for="item in menuoptions"
              :key="item.value"
              :label="item.label"
              @change="power"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialogBtn">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="editsubmitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getpowerlist, deletemenu, addmenu, editmenu } from "../axios/api.js";
export default {
  data() {
    return {
      tableData: [],
      totalpage: 0,
      pageNum: 1,
      options: [],
      menuname: "",
      menuid: "",
      menuidparentName:'',
      input: "",
      addVisible: false,
      editVisible: false,
      userForm: {},
      editForm: {},
      menutypeoption: {
        M: "菜单",
        B: "按钮"
      },
      rules: {
        menuName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入菜单名称"
          }
        ]
      },
      menuoptions: [
        {
          value: "M",
          label: "菜单"
        },
        {
          value: "B",
          label: "按钮"
        }
      ],
      searchShow:false,
      addnewShow:false,
      editShow:false,
      deleteShow:false
    };
  },
  created() {
    this.menulist();
    this.btnShow();
  },
  methods: {
    // 权限按纽
    btnShow(){
      const arr = localStorage.getItem("permissionList")
      var newArr=JSON.parse(arr.replace(/\n/g,"\\n").replace(/\r/g,"\\r")).filter(i=>i.type==="B");
      newArr.forEach(i=>{
        if (i.id==49) {
          this.searchShow = true;
        }
        if (i.id==50) {
          this.addnewShow = true;
        }
        if (i.id==51) {
          this.editShow = true;
        }
        if (i.id==52) {
          this.deleteShow = true;
        }})
    },
    // 获取表格数据
    menulist() {
      const params = {
        parentId: this.menuid,
        menuName: this.menuname
      };
      getpowerlist(params).then(res => {
        // console.log(res);
        var arr = [];
        for (var i in res.rows) {
          if (i < this.pageNum * 10 && i >= (this.pageNum - 1) * 10) {
            arr.push(res.rows[i]);
          }
        }

        this.tableData = arr;
        this.totalpage = res.rows.length;
        this.parentlist()
      });
    },
    // 选项（父级）
    parentlist() {
     this.options= this.tableData.filter(i=>{
     return i.parentId===0||i.parentId==i.id
     })
     console.log(this.options);
    },
    // 查询按钮
    query() {
      this.pageNum = 1;
      this.menulist();
    },
    //重置
    reset() {
      this.pageNum = 1;
      this.menuid = null;
      this.menuname = "";
      this.menulist();
    },
    // 选择菜单类型
    power() {
      console.log(this.menuid);
    },
    //打开添加设备弹窗
    addpower() {
      this.addVisible = true;
    },
    //删除权限
    deletebtn(e) {
      console.log(e);
      this.$confirm("您确定要删除该权限吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            const params = {
              menuId: e
            };
            deletemenu(params).then(res => {
              if (res && res.message === "success") {
                this.$message({
                  message: "删除权限成功",
                  type: "success"
                });
              }
              this.menulist();
            });
          }
        }
      });
    },
    //编辑权限
    edit(e) {
      this.editVisible = true;
      this.editForm = JSON.parse(JSON.stringify(e));
    },
    //确认修改
    editsubmitForm() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          console.log(this.editForm);
          editmenu(this.editForm).then(res => {
            if (res && res.message === "success") {
              this.$refs.editForm.resetFields();
              this.$message.success("权限修改成功");
              this.editVisible = false;
              this.menulist();
            }
          });
        } else {
          return false;
        }
      });
    },
    //确认添加权限
    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          console.log(this.userForm);
          addmenu(this.userForm).then(res => {
            if (res && res.message === "success") {
              this.$refs.userForm.resetFields();
              this.$message.success("添加权限成功");
              this.addVisible = false;
              this.menulist();
            }
          });
        } else {
          return false;
        }
      });
    },
    //权限管理
    operatesizechange(e) {
      console.log(e);
      this.pageNum = e;
      this.menulist();
    }
  },

};
</script>
<style scoped>
.linemain {
  margin-bottom: 10px;
}

.titlebottom {
  border-bottom: 3px solid #10beb8;
  padding-bottom: 3px;
  display: inline-block;
}
</style>